/**
 * Notification Helper Utilities
 * Provides convenient methods for showing notifications
 */

import { useGlobalStore } from '@stores/globalStore';

/**
 * Show a success notification
 */
export function showSuccess(message: string): void {
  const { addNotification } = useGlobalStore.getState();
  addNotification({
    type: 'success',
    message,
  });
}

/**
 * Show an info notification
 */
export function showInfo(message: string): void {
  const { addNotification } = useGlobalStore.getState();
  addNotification({
    type: 'info',
    message,
  });
}

/**
 * Show a warning notification
 */
export function showWarning(message: string): void {
  const { addNotification } = useGlobalStore.getState();
  addNotification({
    type: 'warning',
    message,
  });
}

/**
 * Show an error notification
 * Note: API errors are handled automatically by the API client
 * This should only be used for non-API errors
 */
export function showError(message: string): void {
  const { addNotification, clearNotificationsByType } = useGlobalStore.getState();
  // Clear existing errors to prevent stacking
  clearNotificationsByType('error');
  addNotification({
    type: 'error',
    message,
  });
}

/**
 * Clear all notifications
 */
export function clearAllNotifications(): void {
  const { clearNotifications } = useGlobalStore.getState();
  clearNotifications();
}

/**
 * Clear notifications by type
 */
export function clearNotificationsByType(type: 'success' | 'error' | 'warning' | 'info'): void {
  const { clearNotificationsByType } = useGlobalStore.getState();
  clearNotificationsByType(type);
}